import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTagChip = styled(Chip)(({ theme }) => ({
  border: '0.5px solid #fff',
  backgroundColor: '#3f3f3f',
  color: '#fff',
  fontSize: theme.typography.pxToRem(12),
}));

const DeviceTagChip = ({ label, ...props }) => {
  return <StyledTagChip label={label} size="small" {...props} />;
};

DeviceTagChip.propTypes = {
  label: PropTypes.string.isRequired,
};

export default DeviceTagChip;
